function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

(function() {
  const originalAlert = window.alert;
  window.alert = function(message) {
    if (message && (message.includes('Zepto') || message.includes('rectify configuration') || message.includes('pplr'))) {
      console.warn('Blocked Zepto Alert:', message);
      return;
    }
    originalAlert(message);
  };
})();

class SectionId {
  static #separator = '__';

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section id (e.g. 'template--22224696705326')
  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section name (e.g. 'main')
  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }

  // for a section id (e.g. 'template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. 'template--22224696705326__recommended-products')
  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class BulkModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (this.innerHTML.trim() === '') {
        const productUrl = this.dataset.url.split('?')[0];
        fetch(`${productUrl}?section_id=bulk-quick-order-list`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceQty = html.querySelector('.quick-order-list-container').parentNode;
            this.innerHTML = sourceQty.innerHTML;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    };

    new IntersectionObserver(handleIntersection.bind(this)).observe(
      document.querySelector(`#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`)
    );
  }
}

customElements.define('bulk-modal', BulkModal);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute('selected'))
        .removeAttribute('selected');
      target.selectedOptions[0].setAttribute('selected', 'selected');

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest('.product-form__input')
        .querySelector('[data-selected-value] > .swatch');
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
      ({ dataset }) => dataset.optionValueId
    );
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
          this.remove();
        }

        if (html.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded');
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

class BulkAdd extends HTMLElement {
  constructor() {
    super();
    this.queue = [];
    this.requestStarted = false;
    this.ids = [];
  }

  startQueue(id, quantity) {
    this.queue.push({ id, quantity });
    const interval = setInterval(() => {
      if (this.queue.length > 0) {
        if (!this.requestStarted) {
          this.sendRequest(this.queue);
        }
      } else {
        clearInterval(interval);
      }
    }, 250);
  }

  sendRequest(queue) {
    this.requestStarted = true;
    const items = {};
    queue.forEach((queueItem) => {
      items[parseInt(queueItem.id)] = queueItem.quantity;
    });
    this.queue = this.queue.filter((queueElement) => !queue.includes(queueElement));
    const quickBulkElement = this.closest('quick-order-list') || this.closest('quick-add-bulk');
    quickBulkElement.updateMultipleQty(items);
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;

    if (inputValue < event.target.dataset.min) {
      this.setValidity(event, index, window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min));
    } else if (inputValue > parseInt(event.target.max)) {
      this.setValidity(event, index, window.quickOrderListStrings.max_error.replace('[max]', event.target.max));
    } else if (inputValue % parseInt(event.target.step) != 0) {
      this.setValidity(event, index, window.quickOrderListStrings.step_error.replace('[step]', event.target.step));
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.startQueue(index, inputValue);
    }
  }

  getSectionsUrl() {
    if (window.pageNumber) {
      return `${window.location.pathname}?page=${window.pageNumber}`;
    } else {
      return `${window.location.pathname}`;
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

if (!customElements.get('bulk-add')) {
  customElements.define('bulk-add', BulkAdd);
}


/* Script for change header colors */
let header = document.querySelector('.header');

let menuIcon = document.querySelector('.header__icon--menu');
let menuDrawer = document.querySelector('#Details-menu-drawer-container');

let searchTrigger = document.querySelector('.header__icon--search');
let searchModal = document.querySelector('.header__search details');
let searchModalOverlay = document.querySelector('.modal-overlay');

function updateHeaderClass() {
  const isMenuOpen = menuDrawer.hasAttribute('open');
  const isSearchOpen = searchModal.hasAttribute('open');

  if (isMenuOpen || isSearchOpen) {
    header.classList.add('light__header');
  } else {
    header.classList.remove('light__header');
  }
}

menuIcon.addEventListener('click', () => {
  if (menuDrawer.hasAttribute('open')) {
    header.classList.remove('light__header');
  } else {
    header.classList.add('light__header');
  }
});

searchTrigger.addEventListener('click', () => {
  if (menuDrawer.hasAttribute('open')) {
    header.classList.remove('light__header');
  } else {
    header.classList.add('light__header');
  }
});

searchModalOverlay.addEventListener('click', () => {
  searchModal.removeAttribute('open'); 
  updateHeaderClass();
});

menuDrawer.addEventListener('toggle', updateHeaderClass);
searchModal.addEventListener('toggle', updateHeaderClass);

/* Script hide anoncement bar */

document.addEventListener('DOMContentLoaded', function () {
  const bar = document.querySelector('.utility-bar');
  const close = document.querySelector('.utility-bar__close');

  if (localStorage.getItem('utilityBarClosed') === 'true' && bar) {
    bar.classList.add('is-hidden');
  }

  if (close) {
    close.addEventListener('click', function () {
      localStorage.setItem('utilityBarClosed', 'true');
      bar.classList.add('is-hidden');
    });
  }
});

/* Tooltips */
const formLabels = document.querySelectorAll('.form__label');

const handleOutsideClick = (event) => {
  const activeTooltips = document.querySelectorAll('.tooltip.active');

  activeTooltips.forEach(tooltipPopup => {
    const labelElement = tooltipPopup.closest('.form__label');

    if (labelElement && !labelElement.contains(event.target)) {
      tooltipPopup.classList.remove('active');
    }
  });
};

formLabels.forEach(labelElement => {
  const tooltipIcon = labelElement.querySelector('.tooltip__icon');
  const tooltipPopup = labelElement.querySelector('.tooltip');
  
  if (tooltipIcon && tooltipPopup) {
    tooltipIcon.addEventListener('click', () => {
      tooltipPopup.classList.toggle('active');
    });
  }
});

document.addEventListener('click', handleOutsideClick);

/* Add-ones */
document.addEventListener('DOMContentLoaded', () => {
  const addonLabels = document.querySelectorAll('.product_addones--label');

  addonLabels.forEach(label => {
    const input = label.querySelector('input');
    const content = label.querySelector('.product_addones--content');
    const addonSVG = label.querySelector('.svg__checked');
    const embroideryBlock = document.getElementById('embroidery-block');

    label.addEventListener('click', (e) => {
      if (e.target.tagName === 'INPUT') return;

      const isSingle = label.getAttribute('data-addon-type') === 'single';

      if (isSingle) {
        const parentWrap = label.closest('.product_addones--wrap');
        const allLabelsInGroup = parentWrap.querySelectorAll('.product_addones--label');
        
        allLabelsInGroup.forEach(l => {
          l.querySelector('.product_addones--content').classList.remove('active');
          l.querySelector('.svg__checked').classList.remove('active');
          l.querySelector('input').checked = false;
        });

        content.classList.add('active');
        addonSVG.classList.add('active');
        input.checked = true;
        
        handleEmbroideryLogic();
        if (typeof calculateTotal === 'function') calculateTotal();
      } else {
        setTimeout(() => {
          if (input.checked) {
            content.classList.add('active');
            addonSVG.classList.add('active');
          } else {
            content.classList.remove('active');
            addonSVG.classList.remove('active');
          }
          
          handleEmbroideryLogic();
          if (typeof calculateTotal === 'function') calculateTotal();
        }, 10);
      }
    });

    function handleEmbroideryLogic() {
      if (embroideryBlock && input.getAttribute('data-addon-key') === 'Production Process') {
        const title = input.getAttribute('data-addon-title') || "";
        if (title.toLowerCase().includes('embroider') || title.toLowerCase().includes('embroidey')) {
          embroideryBlock.style.display = 'block';
        } else {
          embroideryBlock.style.display = 'none';
          embroideryBlock.querySelectorAll('input').forEach(i => {
             i.checked = false;
             const targetLabel = i.closest('.product_addones--label');
             if (targetLabel) {
               targetLabel.querySelector('.product_addones--content').classList.remove('active');
               targetLabel.querySelector('.svg__checked').classList.remove('active');
             }
          });
        }
      }
    }
  });
});

/* Copy url */
document.addEventListener("click", function (e) {
  const btn = e.target.closest(".copy-link-btn");
  if (!btn) return;
  e.preventDefault();

  const url = btn.dataset.shareUrl || window.location.href;

  if (!navigator.clipboard) {
    const textArea = document.createElement("textarea");
    textArea.value = url;
    document.body.appendChild(textArea);
    textArea.select();
    try {
      document.execCommand('copy');
      showSuccess(btn);
    } catch (err) {
      console.error('Fallback copy failed', err);
    }
    document.body.removeChild(textArea);
    return;
  }

  function showSuccess(btn) {
    console.log("URL copied successfully!");
  }

  navigator.clipboard.writeText(url)
  .then(() => {
    showSuccess(btn);
  })
  .catch((err) => {
    console.error("Clipboard Error:", err);
    alert("Could not copy link");
  });
});

/* Size guide popups */
const productTemplate = document.querySelector('.template__product');

if (productTemplate) {
  const popupSizeBtn = productTemplate.querySelector('.product__form--sizes');
  const popupSize = popupSizeBtn.querySelector('.size__guide--popup');
  const popupSizeOverlay = popupSizeBtn.querySelector('.size__guide--popupOverlay')

  if (popupSize) {
    popupSizeBtn.addEventListener('click', () => {
      popupSize.classList.toggle('active');
      popupSizeOverlay.classList.toggle('active');
    });
  }
}

/* Loyalty program */

const loyaltyBlock = document.querySelector('.bm_div_product_points');

if (loyaltyBlock) {
  const starIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="loyalty-star">
    <mask id="mask0_2402_30634" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24"><rect width="24" height="24" fill="#D9D9D9"/></mask>
    <g mask="url(#mask0_2402_30634)"><path d="M9.8 13.4885L10.627 10.773L8.452 9.09625H11.1578L12 6.39225L12.8422 9.09625H15.548L13.3577 10.773L14.1845 13.4885L12 11.8L9.8 13.4885ZM6.5 22.2307V15.073C5.86667 14.4115 5.375 13.6468 5.025 12.7788C4.675 11.9109 4.5 10.9847 4.5 10C4.5 7.90767 5.22692 6.13458 6.68075 4.68075C8.13458 3.22692 9.90767 2.5 12 2.5C14.0923 2.5 15.8654 3.22692 17.3193 4.68075C18.7731 6.13458 19.5 7.90767 19.5 10C19.5 10.9847 19.325 11.9109 18.975 12.7788C18.625 13.6468 18.1333 14.4115 17.5 15.073V22.2307L12 20.4807L6.5 22.2307ZM12 16C13.6667 16 15.0833 15.4167 16.25 14.25C17.4167 13.0833 18 11.6667 18 10C18 8.33333 17.4167 6.91667 16.25 5.75C15.0833 4.58333 13.6667 4 12 4C10.3333 4 8.91667 4.58333 7.75 5.75C6.58333 6.91667 6 8.33333 6 10C6 11.6667 6.58333 13.0833 7.75 14.25C8.91667 15.4167 10.3333 16 12 16ZM8 20.0345L12 18.9615L16 20.0345V16.3193C15.4295 16.6911 14.8052 16.9808 14.127 17.1885C13.4487 17.3962 12.7397 17.5 12 17.5C11.2603 17.5 10.5513 17.3962 9.873 17.1885C9.19483 16.9808 8.5705 16.6911 8 16.3193V20.0345Z" fill="#1C1B1F"/></g>
  </svg>`;

  const tooltipHTML = `
    <div class="loyalty-tooltip-wrap">
      <svg class="tooltip__icon" width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg" style="cursor:pointer; vertical-align: middle;">
        <path d="M6.33333 9.48717C6.48589 9.48717 6.61378 9.43556 6.717 9.33233C6.82022 9.22911 6.87183 9.10122 6.87183 8.94867C6.87183 8.79611 6.82022 8.66822 6.717 8.565C6.61378 8.46189 6.48589 8.41033 6.33333 8.41033C6.18078 8.41033 6.05289 8.46189 5.94967 8.565C5.84644 8.66822 5.79483 8.79611 5.79483 8.94867C5.79483 9.10122 5.84644 9.22911 5.94967 9.33233C6.05289 9.43556 6.18078 9.48717 6.33333 9.48717ZM5.83333 7.05133H6.83333V3.05133H5.83333V7.05133ZM6.3345 12.6667C5.4585 12.6667 4.63511 12.5004 3.86433 12.168C3.09356 11.8356 2.42311 11.3844 1.853 10.8145C1.28289 10.2446 0.8315 9.57445 0.498833 8.804C0.166278 8.03356 0 7.21039 0 6.3345C0 5.4585 0.166222 4.63511 0.498667 3.86433C0.831111 3.09356 1.28228 2.42311 1.85217 1.853C2.42206 1.28289 3.09222 0.8315 3.86267 0.498833C4.63311 0.166278 5.45628 0 6.33217 0C7.20817 0 8.03156 0.166222 8.80233 0.498666C9.57311 0.831111 10.2436 1.28228 10.8137 1.85217C11.3838 2.42206 11.8352 3.09222 12.1678 3.86267C12.5004 4.63311 12.6667 5.45628 12.6667 6.33217C12.6667 7.20817 12.5004 8.03156 12.168 8.80233C11.8356 9.57311 11.3844 10.2436 10.8145 10.8137C10.2446 11.3838 9.57445 11.8352 8.804 12.1678C8.03356 12.5004 7.21039 12.6667 6.3345 12.6667Z" fill="#121212"/>
      </svg>
      <div class="tooltip">
        <p><strong>Become a member</strong></p>
        <p>With more ways to unlock exciting perks, this is your all access pass to exclusive rewards.</p>
        <p><a href="https://threadblvd.com/customer_authentication/redirect?locale=en&region_country=US">Join now</a></p>
      </div>
    </div>`;

  loyaltyBlock.insertAdjacentHTML('beforebegin', starIcon);
  loyaltyBlock.insertAdjacentHTML('afterend', tooltipHTML);

  const newLabel = loyaltyBlock.nextElementSibling;
  const icon = newLabel.querySelector('.tooltip__icon');
  const popup = newLabel.querySelector('.tooltip');

  icon.addEventListener('click', (e) => {
    e.stopPropagation();
    popup.classList.toggle('active');
  });
}

const tooltipOutsideClick = (event) => {
  const activeTooltip = document.querySelector('.loyalty-tooltip-wrap .tooltip.active');

  if (activeTooltip) {
    const tooltipContainer = activeTooltip.closest('.loyalty-tooltip-wrap');

    if (tooltipContainer && !tooltipContainer.contains(event.target)) {
      activeTooltip.classList.remove('active');
    }
  }
};

document.addEventListener('click', tooltipOutsideClick);

/* Mobile filter */
document.addEventListener('click', (e) => {
  const title = e.target.closest('.mobile-facets__summary');
  if (!title) return;

  const item = title.closest('.mobile-facets__details');
  if (!item) return;

  const content = item.querySelector('.mobile-facets__submenu');
  const icon = title.querySelector('.facets__icon');

  if (content) content.classList.toggle('active');
  if (icon) icon.classList.toggle('active');
});

/* Custom sort */
function initAllSorts() {
  const containers = document.querySelectorAll('.custom-sort-container');
  
  containers.forEach(container => {
    if (container.dataset.initialized) return;

    const selected = container.querySelector('.custom-sort-selected');
    const list = container.querySelector('.custom-sort-list');
    const items = container.querySelectorAll('.custom-sort-item');
    
    let realSelect = container.querySelector('select');
    if (!realSelect) {
      realSelect = document.querySelector('#SortBy-mobile') || document.querySelector('#SortBy');
    }

    if (!selected || !list || !realSelect) return;

    selected.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      document.querySelectorAll('.custom-sort-list').forEach(l => {
        if (l !== list) l.style.display = 'none';
      });

      const isOpen = list.style.display === 'block';
      list.style.display = isOpen ? 'none' : 'block';
    });

    items.forEach(item => {
      item.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        const val = this.dataset.value || this.getAttribute('data-value');
        const text = this.textContent.trim();

        selected.querySelector('span').textContent = text;
        realSelect.value = val;
        list.style.display = 'none';

        realSelect.dispatchEvent(new Event('change', { bubbles: true }));
        realSelect.dispatchEvent(new Event('input', { bubbles: true }));

        setTimeout(() => {
           const url = new URL(window.location.href);
           if (url.searchParams.get('sort_by') !== val) {
              url.searchParams.set('sort_by', val);
              window.location.href = url.href;
           }
        }, 800);
      });
    });

    container.dataset.initialized = "true";
  });
}

document.addEventListener('click', function() {
  document.querySelectorAll('.custom-sort-list').forEach(l => l.style.display = 'none');
});

document.addEventListener('DOMContentLoaded', initAllSorts);

const filterObserver = new MutationObserver(() => {
  initAllSorts();
});

filterObserver.observe(document.body, {
  childList: true,
  subtree: true
});

if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', initAllSorts);
}

/* Accordion animation */
document.querySelectorAll('.product__accordion details').forEach((details) => {
  const summary = details.querySelector('summary');

  summary.addEventListener('click', (e) => {
    e.preventDefault();

    if (details.hasAttribute('open')) {
      details.classList.remove('is-open');
      
      setTimeout(() => {
        details.removeAttribute('open');
      }, 300);
    } else {
      details.setAttribute('open', '');
      requestAnimationFrame(() => {
        details.classList.add('is-open');
      });
    }
  });
});

/* Clone tooltip text for Zepto app */
const observer = new MutationObserver(() => {
  function cloneLabel(parentSelector, targetSelector) {
    const parent = document.querySelector(parentSelector);
    if (!parent || parent.querySelector('.pplr_ins')) return; 

    const sourceText = parent.querySelector('.ptooltiptext');
    const targetEl = parent.querySelector(targetSelector);

    if (sourceText && targetEl) {
      const label = document.createElement('div');
      label.className = 'pplr_ins';
      label.innerHTML = sourceText.innerHTML;
      targetEl.insertAdjacentElement('afterend', label);
    }
  }

  cloneLabel('.pplr-logo-threat-colors-optional', '.pplr_thumb_image');
  cloneLabel('.pplr-artwork-front-side', '.pplrfileuploadbutton');

  if (document.querySelectorAll('.pplr_ins').length >= 2) {
    observer.disconnect();
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});

/* Change place for Loyalty app */
const loyaltyObserver = new MutationObserver((mutations) => {
  const appBlock = document.querySelector('.bm_top_product_div');
  const targetForm = document.querySelector('.product-form__buttons');
  const pointsEl = document.querySelector('.bm_product_points');

  if (appBlock && targetForm && appBlock.nextElementSibling !== targetForm) {
    targetForm.insertAdjacentElement('beforebegin', appBlock);
  }

  if (pointsEl && pointsEl.textContent.includes('<strong>')) {
    const rawText = pointsEl.textContent;
    pointsEl.innerHTML = rawText; 
    pointsEl.dataset.processed = "true";
  }
});

loyaltyObserver.observe(document.body, {
  childList: true,
  subtree: true,
  characterData: true
});

const formatBytes = (bytes, decimals = 2) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};
// Function to dynamically find location image for ANY product automatically
const getDynamicLocationImage = (title, wrapper) => {
  const query = title.toLowerCase().trim();
  const keywords = query.includes('right') ? ['right'] : 
                   query.includes('back') ? ['back', 'rear'] : 
                   query.includes('left') ? ['left'] : [query];

  // 1. Check Zepto elements inside wrapper
  const innerImg = wrapper.querySelector('img:not([src*="svg"])');
  if (innerImg && innerImg.src) return innerImg.src;

  // 2. Check Zepto Tabs/Views
  const zeptoTabs = document.querySelectorAll('.pplr_tab_index, .pplr-text-thumbnail, .pplr-image-thumbnail, .pplr_thumb_image, .zepto-view-card');
  for (let tab of zeptoTabs) {
    const tabText = (tab.innerText || tab.getAttribute('title') || tab.getAttribute('data-title') || '').toLowerCase();
    if (keywords.some(k => tabText.includes(k))) {
      const img = tab.querySelector('img');
      if (img && img.src) return img.src;
      const bg = tab.style.backgroundImage || window.getComputedStyle(tab).backgroundImage;
      if (bg && bg.includes('url(')) {
        return bg.replace(/url\(['"]?(.*?)['"]?\)/i, '$1').replace(/["']/g, '');
      }
    }
  }

  // 3. Check Shopify Gallery Images (by alt text or filename)
  const galleryImages = Array.from(document.querySelectorAll('.product__media-list img, .thumbnail-list img, media-gallery img, .product__media img'))
    .filter(img => img.src && !img.src.includes('svg'));

  for (let img of galleryImages) {
    const alt = (img.alt || '').toLowerCase();
    const src = (img.src || '').toLowerCase();
    if (keywords.some(k => alt.includes(k) || src.includes(k))) {
      return img.currentSrc || img.src;
    }
  }

  // 4. Fallback to product gallery angle positions
  if (query.includes('right') && galleryImages.length >= 2) {
    return galleryImages[1].currentSrc || galleryImages[1].src;
  }
  if (query.includes('back') && galleryImages.length >= 3) {
    return galleryImages[2].currentSrc || galleryImages[2].src;
  }

  return '';
};

const customizePplrCheckboxes = (wrapper) => {
  const isSideBlock = wrapper.className.includes('-side');
  if (!isSideBlock || wrapper.querySelector('.custom-pplr-checkbox-row')) return;

  const hiddenInput = wrapper.querySelector('input.pplr_select');
  const dropItem = wrapper.querySelector('.pplr-drop-item');
  const label = wrapper.querySelector('.pplrlabel');
  
  if (!hiddenInput || !dropItem || !label) return;

  const price = dropItem.dataset.pplr_price || "5";
  let title = label.innerText.split('$')[0].split('+')[0].trim();
  if (!title) title = dropItem.dataset.value || "Side option";

  // Dynamic Image Search
  let imgSrc = getDynamicLocationImage(title, wrapper);
  const imgHtml = `<div class="pplr-card-img-wrap js-dynamic-loc-img"><img src="${imgSrc}" alt="${title}" style="${imgSrc ? '' : 'display:none;'}"></div>`;

  const checkboxContainer = document.createElement('div');
  checkboxContainer.className = 'custom-pplr-checkbox-row';
  checkboxContainer.innerHTML = `
    <label class="custom-card-label">
        <div class="custom-checkbox-wrapper">
            <input type="checkbox" class="js-pplr-custom-check">
            <span class="custom-checkmark"></span>
        </div>
        ${imgHtml}
        <div class="custom-card-text-col">
            <span class="custom-card-title">${title}</span>
            <span class="custom-card-price">+ $${price}</span>
        </div>
    </label>
  `;

  // Retrying once gallery/Zepto is fully loaded
  if (!imgSrc) {
    setTimeout(() => {
      const retrySrc = getDynamicLocationImage(title, wrapper);
      const imgEl = checkboxContainer.querySelector('.js-dynamic-loc-img img');
      if (retrySrc && imgEl) {
        imgEl.src = retrySrc;
        imgEl.style.display = 'block';
      }
    }, 600);
  }

  const customCheck = checkboxContainer.querySelector('.js-pplr-custom-check');
  if (hiddenInput.value !== "") customCheck.checked = true;

  customCheck.addEventListener('change', function() {
    const isChecked = this.checked;
    const frameId = hiddenInput.dataset.frame;

    if (isChecked) {
      wrapper.querySelectorAll('.pplr_selected, .active').forEach(el => {
        el.classList.remove('pplr_selected', 'active');
      });

      if (typeof pplrselecteritemoption === 'function') {
        pplrselecteritemoption(dropItem);
      }
    } else {
      const dummy = document.createElement('span');
      dummy.dataset.value = "";
      dummy.dataset.pplr_price = "0";
      dummy.dataset.variant = "";
      dummy.dataset.frame = frameId;

      if (typeof pplrselecteritemoption === 'function') {
        pplrselecteritemoption(dummy);
      }

      hiddenInput.value = "";
      
      if (typeof updateconditionFeild === 'function') {
        updateconditionFeild(hiddenInput, frameId, false, true);
      }
    }

    setTimeout(() => {
      if (window.PPLR_CAlCULATE_PRICE) window.PPLR_CAlCULATE_PRICE();
      hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
    }, 50);
  });

  label.style.display = 'none';
  wrapper.appendChild(checkboxContainer);
};

const customizeUploadDisplay = (li) => {
  if (li.dataset.customized === "true") return;

  const fileName = li.dataset.name || "Uploaded file";
  const blobUrl = li.querySelector('.pplr_img')?.href;
  const infoContainer = document.createElement('div');
  infoContainer.className = 'pplr-file-info';
  
  let sizeText = "Calculating...";
  if (blobUrl && blobUrl.startsWith('blob:')) {
    fetch(blobUrl).then(r => r.blob()).then(blob => {
      const formattedSize = formatBytes(blob.size);
      const sizeEl = infoContainer.querySelector('.pplr-file-size');
      if (sizeEl) sizeEl.textContent = formattedSize;
    }).catch(() => {
      const sizeEl = infoContainer.querySelector('.pplr-file-size');
      if (sizeEl) sizeEl.textContent = "Uploaded";
    });
  }

  infoContainer.innerHTML = `
    <div class="pplr-file-details">
      <span class="pplr-file-name">${fileName}</span>
      <span class="pplr-file-size">${sizeText}</span>
    </div>
    <div class="pplr-file-status">Complete</div>
  `;
  
  li.appendChild(infoContainer);
  li.dataset.customized = "true";
};

const setupUploadButtons = () => {
  document.querySelectorAll('.pplrfileuploadbutton').forEach(fileButton => {
    const fileInput = fileButton.querySelector('input[type="file"]');
    if (fileInput && !fileButton.querySelector('.custom-upload-label')) {
      const labelContainer = document.createElement('div');
      labelContainer.className = 'custom-upload-label';
      labelContainer.innerHTML = `
        <div class="upload-main-row">
          <svg class="upload-icon-svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1a273a" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
            <polyline points="17 8 12 3 7 8"></polyline>
            <line x1="12" y1="3" x2="12" y2="15"></line>
          </svg>
          <span class="upload-title">Upload Artwork</span>
        </div>
        <span class="upload-subtitle">PNG, JPG or SVG (Max 50MB)</span>
      `;
      fileButton.prepend(labelContainer);
      fileInput.style.zIndex = "20";
    }
  });
};


const initAll = () => {
  setupUploadButtons();
  document.querySelectorAll('.pplr-wrapper').forEach(customizePplrCheckboxes);
  document.querySelectorAll('.pplr_img_w').forEach(customizeUploadDisplay);
};
const observerAll = new MutationObserver(() => {
  initAll();
});

observerAll.observe(document.body, {
  childList: true,
  subtree: true
});

initAll();
/* Change place for image uploading locations */
(function () {

  const observer = new MutationObserver(() => {
    const combinedReady = initCombinedWrapper();
    const sideReady = initSideWrapper();

    if (combinedReady && sideReady) {
      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  function initCombinedWrapper() {
    const source = document.querySelector('.pplr-additional-locations');
    const target = document.querySelector('.pplr_tab_wrapper');
    const firstTab = document.querySelector('.pplr_tab_index');

    if (!source || !target || !firstTab) return false;
    if (document.querySelector('.pplr-combined-wrapper')) return true;

    firstTab.classList.add('pplr_tab_index--first');

    const combinedWrapper = document.createElement('div');
    combinedWrapper.className = 'pplr-combined-wrapper';

    const headerClone = document.createElement('div');
    headerClone.className = 'pplr-custom-header-clone';
    headerClone.innerHTML = source.innerHTML;

    target.insertAdjacentElement('beforebegin', combinedWrapper);
    combinedWrapper.appendChild(headerClone);
    combinedWrapper.appendChild(target);

    source.style.display = 'none';

    return true;
  }

  function initSideWrapper() {
    const source = document.querySelector('.pplr-additional-locations');
    if (!source) return false;

    const sideBlocks = document.querySelectorAll(
      '.pplr-left-side, .pplr-right-side, .pplr-back-side'
    );

    if (!sideBlocks.length) return false;
    if (document.querySelector('.pplr-sides-wrapper')) return true;

    const wrapper = document.createElement('div');
    wrapper.className = 'pplr-sides-wrapper';

    sideBlocks.forEach(block => wrapper.appendChild(block));

    source.insertAdjacentElement('afterend', wrapper);

    return true;
  }

})();